import {handleShowMore} from "./handleShowMore";

export const productFilters = (function () {
  'use strict';

  var init = function () {
    var megafilter = document.getElementById("plp-filters-base");
    if (megafilter == null) return;
    var showMoreTriggers = megafilter.querySelectorAll(".product-listing-filters__show-more");
    var clearSectionBtns = megafilter.querySelectorAll(".plp-filter-clear-section");

    limitFilterOptions();
    var i;

    for (i = 0; i < showMoreTriggers.length; i++) {
      showMoreTriggers[i].onclick = handleShowMore;
    }
    for (i = 0; i < clearSectionBtns.length; i++) {
      clearSectionBtns[i].onclick = handleSectionClear;
    }
  };

  var limitFilterOptions = function () {
    var megafilter= document.getElementById("plp-filters-base");
    if (megafilter == null) return;
    var optContainers = megafilter.querySelectorAll(".product-listing-filters__select-opt-container");
    var showMoreLinks = megafilter.querySelectorAll(".product-listing-filters__show-more");
    var opts;

    for (var i = 0 ; i < optContainers.length; i ++) {
      var limitTo = parseInt(optContainers[i].dataset.displayRowsLimit);
      opts = optContainers[i].children;
      if (opts.length > limitTo) {
        for (var j = limitTo; j < opts.length ; j++) {
          opts[j].classList.add("hide");
        }
      } else {
        showMoreLinks[i].style.display = "none";
      }
    }
  };

  var handleSectionClear = function (e) {
    e.stopPropagation();
    var self = e.currentTarget;
    var checkboxes = self.parentElement.nextElementSibling ? self.parentElement.nextElementSibling.querySelectorAll("input[type=checkbox]") : null;


    for (var i = 0; i < checkboxes.length; i ++) {
      checkboxes[i].checked = false;
      checkboxes[i].indeterminate = false;
    }
  };

  return {
    init: init
  };

});
